'use strict';

// Polyfills
require('es6-promise').polyfill();
require('es6-shim');

// App CSS files
require('font-awesome-webpack');
require('styles/main.less');

// App JavaScript files
require('scripts/app.js');



//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 110
// module chunks = 0